import apiClient from 'ps-components/lib/apiClient';
import { PRICING_TYPE } from '../../SkillGeoDifferential/SkillGeoDifferentialReducer';
import { getCurrentAgingCode } from '../helper';
import { getColumnIndex } from 'ps-components/AdvancedTable/GenericGrid/GenericGridHelper';
import GG_DEFAULTS from '../../../lib/genericGridDefaults';
import addAlert from 'ps-components/AlertToast/addAlert';

export const GET_PRICING_DETAILS_VIEWS_START = 'GET_PRICING_DETAILS_VIEWS_START';
export const GET_PRICING_DETAILS_VIEWS_SUCCESS = 'GET_PRICING_DETAILS_VIEWS_SUCCESS';
export const GET_PRICING_DETAILS_VIEWS_ERROR = 'GET_PRICING_DETAILS_VIEWS_ERROR';

export const GET_PRICING_DETAILS_VIEWS_SLOTTED_START = 'GET_PRICING_DETAILS_VIEWS_SLOTTED_START';
export const GET_PRICING_DETAILS_VIEWS_SLOTTED_SUCCESS = 'GET_PRICING_DETAILS_VIEWS_SLOTTED_SUCCESS';
export const GET_PRICING_DETAILS_VIEWS_SLOTTED_ERROR = 'GET_PRICING_DETAILS_VIEWS_SLOTTED_ERROR';

export const SET_PRICING_DETAILS_SELECTED_VIEW_START = 'SET_PRICING_DETAILS_SELECTED_VIEW_START';
export const SET_PRICING_DETAILS_SELECTED_VIEW_SUCCESS = 'SET_PRICING_DETAILS_SELECTED_VIEW_SUCCESS';
export const SET_PRICING_DETAILS_SELECTED_VIEW_ERROR = 'SET_PRICING_DETAILS_SELECTED_VIEW_ERROR';

export const GET_PRICING_DETAILS_SELECTED_VIEW_START = 'GET_PRICING_DETAILS_SELECTED_VIEW_START';
export const GET_PRICING_DETAILS_SELECTED_VIEW_SUCCESS = 'GET_PRICING_DETAILS_SELECTED_VIEW_SUCCESS';
export const GET_PRICING_DETAILS_SELECTED_VIEW_ERROR = 'GET_PRICING_DETAILS_SELECTED_VIEW_ERROR';

export const GET_PRICING_DETAILS_RANGE_CHART_DATA_START = 'GET_PRICING_DETAILS_RANGE_CHART_DATA_START';
export const GET_PRICING_DETAILS_RANGE_CHART_DATA_SUCCESS = 'GET_PRICING_DETAILS_RANGE_CHART_DATA_SUCCESS';
export const GET_PRICING_DETAILS_RANGE_CHART_DATA_ERROR = 'GET_PRICING_DETAILS_RANGE_CHART_DATA_ERROR';

export const SET_SELECTED_JOB_ID = 'SET_SELECTED_JOB_ID';
export const SET_SELECTED_AGING_FACTOR = 'SET_SELECTED_AGING_FACTOR';
export const UPDATE_AGING_FACTOR_START = 'UPDATE_AGING_FACTOR_START';
export const UPDATE_AGING_FACTOR_SUCCESS = 'UPDATE_AGING_FACTOR_SUCCESS';
export const UPDATE_AGING_FACTOR_FAILED = 'UPDATE_AGING_FACTOR_FAILED';
export const SET_SELECTED_BENCHMARK_YEAR = 'SET_SELECTED_BENCHMARK_YEAR';
export const UPDATE_MERIT_MATCH_SUMMARIES_START = 'UPDATE_MERIT_MATCH_SUMMARIES_START';
export const UPDATE_MERIT_MATCH_SUMMARIES_SUCCESS = 'UPDATE_MERIT_MATCH_SUMMARIES_SUCCESS';
export const UPDATE_MERIT_MATCH_SUMMARIES_FAILED = 'UPDATE_MERIT_MATCH_SUMMARIES_FAILED';
export const GET_PRICING_SURVEY_LIST = 'GET_PRICING_SURVEY_LIST';
export const GET_PRICING_SURVEY_LIST_SUCCESS = 'GET_PRICING_SURVEY_LIST_SUCCESS';
export const GET_PRICING_SURVEY_LIST_ERROR = 'GET_PRICING_SURVEY_LIST_ERROR';
export const RESET_JOB_PRICING_REDUCER = 'RESET_JOB_PRICING_REDUCER';
export const GET_LAST_MODIFIED_DATE_SUCCESS = 'GET_LAST_MODIFIED_DATE_SUCCESS';
export const GET_LAST_MODIFIED_DATE_ERROR = 'GET_LAST_MODIFIED_DATE_ERROR';
export const ADD_SELECTED_CUT_ID = 'ADD_SELECTED_CUT_ID';
export const REMOVE_SELECTED_CUT_ID = 'REMOVE_SELECTED_CUT_ID';

const PRICING_PAGE_NAME = 'price3';
const SLOTTED_PAGE_NAME = 'slot_job';

export function setSelectedJobId(orgJobId) {
  return { type: SET_SELECTED_JOB_ID, orgJobId };
}

export function getPricingViews(masterAccountId, isSlotted) {
  return async dispatch => {
    const errorMessage = 'Error retrieving pricing views';

    try {
      dispatch({ type: GET_PRICING_DETAILS_VIEWS_START });

      const result = await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/views`, {
        params: {
          contextName: isSlotted ? SLOTTED_PAGE_NAME : PRICING_PAGE_NAME,
          portAll: true,
          isFacet: false
        }
      });

      if (result.status < 300) {
        dispatch({
          type: GET_PRICING_DETAILS_VIEWS_SUCCESS,
          pricingViews: result.data?.data?.views,
          defaultViewId: result?.data?.data?.defaultViewId,
          isSlotted
        });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log('Error in getPricingViews: ', error);
      dispatch({ type: GET_PRICING_DETAILS_VIEWS_ERROR });
    }
  };
}

export function getSelectedPricingView(masterAccountId, isSlotted) {
  return async dispatch => {
    const errorMessage = 'Error getting selected pricing view';

    try {
      dispatch({ type: GET_PRICING_DETAILS_SELECTED_VIEW_START });

      const result = await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/views/last-viewed`, {
        params: {
          contextName: isSlotted ? SLOTTED_PAGE_NAME : PRICING_PAGE_NAME
        }
      });

      if (result.status < 300) {
        dispatch({
          type: GET_PRICING_DETAILS_SELECTED_VIEW_SUCCESS,
          selectedViewPk: result.data?.data?.view_pk,
          isSlotted
        });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log('Error in getSelectedPricingView: ', error);
      dispatch({ type: GET_PRICING_DETAILS_SELECTED_VIEW_ERROR });
    }
  };
}

export function setSelectedPricingView(viewPk, masterAccountId, isSlotted) {
  return async dispatch => {
    const errorMessage = 'Error setting selected pricing view';

    try {
      dispatch({ type: SET_PRICING_DETAILS_SELECTED_VIEW_START });

      const result = await apiClient.apiPost(`/cms/api/accounts/${masterAccountId}/views/last-viewed`, {
        contextName: isSlotted ? SLOTTED_PAGE_NAME : PRICING_PAGE_NAME,
        viewId: viewPk
      });

      if (result.status < 300) {
        dispatch({ type: SET_PRICING_DETAILS_SELECTED_VIEW_SUCCESS, selectedViewPk: viewPk, isSlotted });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log('Error in setSelectedPricingView: ', error);
      dispatch({ type: SET_PRICING_DETAILS_SELECTED_VIEW_ERROR });
    }
  };
}

export function setSelectedAgingFactor(agingFactor) {
  return { type: SET_SELECTED_AGING_FACTOR, agingFactor };
}

export function updateAgingFactor(orgJobId, agingCode, benchmarkYear, currency = undefined) {
  return async dispatch => {
    const errorMessage = 'Error updating aging factor';

    try {
      dispatch({ type: UPDATE_AGING_FACTOR_START });
      const result = await apiClient.apiPut('/api/market-pricing/jobs/updateAgingFactor', {
        orgJobId,
        agingCode,
        benchmarkYear,
        currency
      });
      dispatch({ type: UPDATE_AGING_FACTOR_SUCCESS, agingCode });

      return result;
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log(error);
      dispatch({ type: UPDATE_AGING_FACTOR_FAILED });
      throw error;
    }
  };
}

export function setSelectedBenchmarkYear(benchmarkYear) {
  benchmarkYear = parseInt(benchmarkYear);
  return { type: SET_SELECTED_BENCHMARK_YEAR, benchmarkYear };
}

export function updateMeritMatchSummaries(
  orgJobId,
  benchmarkAdjustment,
  benchmarkComment,
  benchmarkYear,
  editPastYears
) {
  return async dispatch => {
    const errorMessage = 'Error updating pricing composite information';

    try {
      dispatch({ type: UPDATE_MERIT_MATCH_SUMMARIES_START });
      await apiClient.apiPut('/api/market-pricing/jobs/updateMeritMatchSummaries', {
        orgJobId,
        benchmarkAdjustment,
        benchmarkComment,
        benchmarkYear,
        editPastYears
      });
      dispatch({ type: UPDATE_MERIT_MATCH_SUMMARIES_SUCCESS });
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log(error);
      dispatch({ type: UPDATE_MERIT_MATCH_SUMMARIES_FAILED });
    }
  };
}

export function getJobPricingDetails(job, benchmarkYear, displayIn, search, masterAccountId, viewName, showZeroWeightMatches = true) {
  return async dispatch => {
    const errorMessage = 'Error retrieving pricing details';

    try {
      dispatch({ type: GET_PRICING_SURVEY_LIST });
      const options = {
        benchmarkYear,
        jobCode: job.code,
        jobCodeKey: job.codeKey,
        displayIn: displayIn.toLowerCase(),
        currency: job.currency,
        showZeroWeightMatches
      };
      if (viewName) {
        options.viewName = viewName;
      }
      const result = await search(`/cms/api/accounts/${masterAccountId}/org-jobs/pricing`, options, 'post');

      if (result?.result?.status === 200) {
        const resultData = result.result.data;

        if (resultData.metadata.pricingType === PRICING_TYPE.SLOTTED) {
          const orgJobIdIndex = getColumnIndex(resultData, GG_DEFAULTS.ORG_JOB_ID);

          const selectedSlottedJobs = orgJobIdIndex !== -1 ? resultData.data.map(row => row[orgJobIdIndex]) : [];

          dispatch({ type: GET_PRICING_SURVEY_LIST_SUCCESS, selectedSlottedJobs });
        } else {
          const cutIDIndex = getColumnIndex(resultData, 'cut_id_default');
          const selectedCutIDs = cutIDIndex > -1 ? resultData.data.map(row => row[cutIDIndex]) : [];
          dispatch({ type: GET_PRICING_SURVEY_LIST_SUCCESS, selectedCutIDs });
        }
        const agingCode = getCurrentAgingCode(resultData);
        if (agingCode) dispatch({ type: SET_SELECTED_AGING_FACTOR, agingFactor: agingCode });

        return result;
      }

      throw Error(errorMessage);
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log(error);
      dispatch({ type: GET_PRICING_SURVEY_LIST_ERROR });
    }
  };
}

export function addSelectedCutID(cutID) {
  return { type: ADD_SELECTED_CUT_ID, cutID };
}

export function removeSelectedCutID(cutID) {
  return { type: REMOVE_SELECTED_CUT_ID, cutID };
}

export function resetJobPricingReducer() {
  return { type: RESET_JOB_PRICING_REDUCER };
}

export function getLastModifiedDate(orgJobId, benchmarkYear) {
  return async dispatch => {
    if (orgJobId && benchmarkYear) {
      const errorMessage = 'Error retrieving last modified date';

      try {
        const result = await apiClient.apiGet('/api/market-pricing/jobs/getLastModifiedDate', {
          params: {
            orgJobId,
            benchmarkYear
          }
        });

        dispatch({ type: GET_LAST_MODIFIED_DATE_SUCCESS, lastModifiedDate: result.data.lastModifiedDate });
      } catch (error) {
        if (error.response.status !== 404) {
          addAlert(errorMessage, 'warning');
          console.error(error);
        }

        dispatch({ type: GET_LAST_MODIFIED_DATE_ERROR });
      }
    }
  };
}

export function getRangeChartData(orgJobCode, orgJobCodeKey, benchmarkYear) {
  return async dispatch => {
    const errorMessage = 'Error retrieving range chart data';

    try {
      dispatch({ type: GET_PRICING_DETAILS_RANGE_CHART_DATA_START });
      const result = await apiClient.apiGet('/api/market-pricing/range-chart/rangeChartData', {
        params: {
          orgJobCode,
          orgJobCodeKey,
          benchmarkYear
        }
      });

      dispatch({ type: GET_PRICING_DETAILS_RANGE_CHART_DATA_SUCCESS, rangeChartData: result.data.result });
    } catch (error) {
      addAlert(errorMessage, 'warning');
      console.log(error);
      dispatch({ type: GET_PRICING_DETAILS_RANGE_CHART_DATA_ERROR });
    }
  };
}
